import { sharedSheet } from "../styles/sharedStyles.js";
import componentStylesText from "./AcceptedNextBestActionBlockComponent.css?inline";
import { type AcceptableNextBestAction } from "../types.js";

const componentSheet = new CSSStyleSheet();
componentSheet.replaceSync(componentStylesText);

/**
 * AcceptedNextBestActionBlockComponent — A component for rendering an accepted NBA as a user message.
 */
export class AcceptedNextBestActionBlockComponent extends HTMLElement {
    private textSpan: HTMLSpanElement | null = null;

    static get observedAttributes(): string[] {
        return ["nba", "role"];
    }

    /**
     * Returns the text content for accessibility aggregation.
     */
    get accessibilityText(): string {
        const nbaAttr = this.getAttribute("nba");
        if (nbaAttr) {
            try {
                const nba = JSON.parse(nbaAttr) as AcceptableNextBestAction;
                return nba.text;
            } catch {
                return "";
            }
        }
        return "";
    }

    connectedCallback(): void {
        if (!this.shadowRoot) {
            const shadow = this.attachShadow({ mode: "open" });
            shadow.adoptedStyleSheets = [sharedSheet, componentSheet];
            this.render();
        }
        this.updateContent();
    }

    attributeChangedCallback(name: string): void {
        if (name === "nba") {
            this.updateContent();
            this.dispatchEvent(new CustomEvent("text-update", { bubbles: true }));
        }
    }

    private render(): void {
        const bubble = document.createElement("div");
        bubble.className = "chat-message__bubble";
        
        this.textSpan = document.createElement("span");
        this.textSpan.className = "chat-message__text";

        bubble.appendChild(this.textSpan);
        this.shadowRoot?.appendChild(bubble);
    }

    private updateContent(): void {
        if (this.textSpan) {
            this.textSpan.textContent = this.accessibilityText;
        }
    }
}

if (!customElements.get("jt-accepted-next-best-action-block")) {
    customElements.define("jt-accepted-next-best-action-block", AcceptedNextBestActionBlockComponent);
}
